import * as _ from 'lodash';
import { getPublicImg } from '../path/pathService';

const IMAGE_TYPE = { local: 'local', remote: 'remote' };
export const REMOTE_IMG_REGEXP = /((http)s?:\/\/.*\.(?:png|jpg|jpeg|gif|png|svg)$)/i;
const LOCAL_IMG_REGEXP = /(\/.*\.(?:png|jpg|jpeg|gif|png|svg)$)/i;

export let getImagesFromObject = (data, baseUrl) => {
  let getImages = responseData => {
    if (_.isArray(responseData)) {
      // Array
      responseData.forEach(o => getImages(o));
    } else {
      // Object
      for (let property in responseData) {
        if (_.has(responseData, property)) {
          // Sub-Object
          const value = responseData[property];
          if (_.isObject(value)) {
            getImages(value);
          } else {
            // Plain Property
            let image = getImageUrl(value, baseUrl);
            if (image) {
              remoteImages.push(image);
            }
          }
        }
      }
    }
  };
  let remoteImages = [];
  getImages(data);
  return remoteImages;
};

let getImageUrl = (value, baseUrl) => {
  let image;
  let imageType = matchImageType(value);

  if (imageType === IMAGE_TYPE.local) {
    image = getPublicImg(value, baseUrl);
  } else if (imageType === IMAGE_TYPE.remote) {
    image = value;
  }
  return image;
};

let matchImageType = value => {
  if (new RegExp(REMOTE_IMG_REGEXP).test(value)) {
    return IMAGE_TYPE.remote;
  } else if (new RegExp(LOCAL_IMG_REGEXP).test(value)) {
    return IMAGE_TYPE.local;
  }
};

export let fetchRemoteImages = remoteImages => {
  if (remoteImages.length) {
    remoteImages.forEach(imageUrl => {
      const image = new Image();
      image.src = imageUrl;
    });
  }
};
